module.exports = __webpack_public_path__ + "assets/img/c287414c50b2a2937aa67e5ff9e4e4a7.svg";